import rill from "rill";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import ensurePerformUpgrade from "../../../middleware/ensure-perform-upgrade";
import {
  getRoot,
  postApprove,
  postBulkApprove,
  postEditEmail,
  postReject,
} from "./access-requests.controller";

const AccessRequests = (app) => {
  app.at(
    "/access-requests/*",
    rill().setup((app) => {
      app
        .get(
          "/",
          ensurePerformUpgrade,
          (ctx, next) =>
            checkOrganizationSectionPermission(
              ctx,
              next,
              ["PERFORM"],
              "/coaching-portal/athletes"
            ),
          getRoot
        )
        .post("/approve", postApprove)
        .post("/reject", postReject)
        .post("/bulk-approve", postBulkApprove)
        .post("/edit-email", postEditEmail);
    })
  );
};

export default AccessRequests;
